<template>
  <div class="container-fluid">
      <div class="page-header min-height-100" >
        
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">

              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{ veiculo.marca || 'Novo Veículo' }}</h5>
                <p class="mb-0 font-weight-bold text-sm"></p>
              </div>
            </div>
            <div
              class="mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >
                  <li class="nav-item">
                    
                      <button
                        class="mb-0 btn bg-gradient-success btn-sm me-2"
                        type="button"
                        name="button"
                        @click="salvarVeiculo(veiculo)"
                      >
                        Salvar
                      </button>

                  </li>
                  <li class="nav-item">
                      <button
                        class="mb-0 btn btn-outline-danger btn-sm"
                        type="button"
                        name="button"
                        @click="fecharVeiculo()"
                      >
                        Cancelar
                      </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="mt-4 col-lg-8 mt-lg-0">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-sm-6">
                <label>Name</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="veiculo.marca"
                />
              </div>
              <div class="col-12 col-sm-6">
                <label>Modelo</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="veiculo.modelo"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <label class="mt-4">Placa</label>
                <input class="form-control" type="text" v-model="veiculo.placa" />
              </div>
              <div class="col-3">
                <label class="mt-4">Quilometragem</label>
                <input class="form-control" type="text" v-model="veiculo.quilometragem" />
              </div>
              <div class="col-3">
                <label class="mt-4">Capacidade</label>
                <input class="form-control" type="number" v-model="veiculo.capacidade" />
              </div>
              <div class="col-3">
                <label class="mt-4">Ano</label>
                <input class="form-control" type="text" v-model="veiculo.ano" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <label class="mt-4">Tipo Combustível</label>
                <select
                  id="choices-category-edit"
                  class="form-control"
                  name="choices-category"
                  v-model="veiculo.tipo_combustivel"
                >
                  <option value="Diesel" selected>Diesel</option>
                  <option value="Gasolina">Gasolina</option>
                </select>
                <label>Disponibilidade</label>
                <select
                  id="choices-color-edit"
                  class="form-control"
                  name="choices-color"
                  v-model="veiculo.status"
                >
                  <option value="Disponível" selected>Disponível</option>
                  <option value="Indisponível">Indisponível</option>
                </select>
              </div>
              <div class="mt-4 col-sm-6 mt-sm-0">
                <label class="mt-4">Tipo Veículo</label>
                <select
                  id="choices-color-edit"
                  class="form-control"
                  name="choices-color"
                  v-model="veiculo.tipo"
                >
                  <option value="Utilitario" selected>Utilitario</option>
                  <option value="Carro">Carro</option>
                </select>
                <label>Operação</label>
                <select
                  id="choices-category"
                  class="form-control"
                  name="choices-category"
                  v-model="veiculo.operacao_id"
                  
                >
                <option v-for="item in operacoes" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
                </select>
                 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Quill from "quill";
import Choices from "choices.js";

export default {
  name: "FormularioVeiculo",
  props: {
      veiculo: {
        type: Object,
        default: () => {
          {};
        },
      },
      operacoes: {
        type: Array,
        default: () => {
          [];
        },
      },
      salvarVeiculo: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      fecharVeiculo: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      }
    },
  mounted() {


  },
  setup(props) {

      const salvarVeiculo = (veiculo) => {
          props.salvarVeiculo(veiculo); // Define o novo cen tro do mapa
      };

      const fecharVeiculo = () => {
          props.fecharVeiculo(); // Define o novo cen tro do mapa
      };

      // Retorna os métodos ou variáveis que você quer expor
      return {
        salvarVeiculo,
        fecharVeiculo
      };
  }
};
</script>
